import request from "@/utils/request";

export function getList(data) {
  return request({
    url: "/BookingManagement/List",
    method: "get",
    params: data
  });
}
export function getDetail(data) {
  return request({
    url: "/BookingManagement/Detail",
    method: "get",
    params: data
  });
}
export function getAlloc(params) {
  return request({
    url: "/BookingManagement/AllocationTable",
    method: "get",
    params
  });
}
export function setAlloc(data) {
  return request({
    url: "/BookingManagement/SaveAllocation",
    method: "post",
    data
  });
}
export function clearAlloc(data) {
  return request({
    url: "/BookingManagement/ClearAllocation",
    method: "post",
    data
  });
}
export function finance(data) {
  return request({
    url: "/BookingManagement/DebitNote",
    method: "get",
    params: data
  });
}
export function financeDetail(data) {
  return request({
    url: "/BookingManagement/DebitNoteDetail",
    method: "post",
    data
  });
}
export function updDebitNote(data) {
  return request({
    url: "/BookingManagement/UpdateDebitNote",
    method: "post",
    data
  });
}
export function addDebitNote(data) {
  return request({
    url: "/BookingManagement/CreateDebitNote",
    method: "post",
    data
  });
}
export function confirmDebit(data) {
  return request({
    url: "/BookingManagement/Post",
    method: "post",
    data
  });
}
export function getPaymentDescription(params) {
  return request({
    url: "/BookingManagement/PaymentDescription",
    method: "get",
    params
  });
}
export function setOfficial(data) {
  return request({
    url: "/BookingManagement/SetOfficial",
    method: "post",
    data
  });
}
